import React from 'react';
import Dialog from '../../../toolkit/dialog';

export interface DialogProps {
  dialogInstance?: Dialog;
}

export default class DialogComponent<P extends DialogProps = {}, S = {}, SS = any> extends React.PureComponent<P, S, SS> {

  protected dialog: Dialog | null = null;

  constructor(props: P) {
    super(props);
    this.dialog = props.dialogInstance as Dialog;
  }

  protected show = () => {
    if (this.dialog) {
      this.dialog.show(this.props)
    }
  }

  protected close = (data?: any) => {
    if (this.dialog) {
      this.dialog.close(data);
    }
  }

  protected resolve = (data: any = null) => {
    if (this.dialog) {
      this.dialog.resolve(data);
    }
  }

}
